








import Vue, { PropType } from 'vue';
import axios from 'axios';

import FailedToLoadRemoteContent from '@/components/partials/remoteContent/FailedToLoadRemoteContent.vue';

export default Vue.extend({
  name: 'RemoteContentPresenter',
  components: {
    FailedToLoadRemoteContent,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data(): {
    loading: boolean;
    urlContent: string | undefined;
    failedToLoad: boolean;
  } {
    return {
      loading: false,
      urlContent: undefined,
      failedToLoad: false,
    };
  },
  async mounted() {
    this.failedToLoad = false;
    this.urlContent = undefined;
    this.loading = true;
    try {
      const remoteData = await axios.get<string>(this.url);
      this.urlContent = remoteData.data;
      this.$emit('loaded-successfully');
    } catch (e) {
      this.failedToLoad = true;
      this.$emit('loading-failed');
    } finally {
      this.loading = false;
    }
  },
});
